import { NVSystemBaseApi } from "./NVSystemBaseApi";
import { Methods } from '@newview/infrastructure';


export class UserprojectdatarelationApi extends NVSystemBaseApi {

  public get ControllerName(): any {
    return 'userprojectdatarelation'
  }

  /**
   * 分项id查询用户列表
   * @param projectDataId 
   * @returns 
   */
  public getUserInfoList(projectDataId) {
    return this.send({ projectDataId: projectDataId }, "getUserInfoList", Methods.GET)
  }

  /**
   * 保存子项目和用户之间的关系 (分派人员)
   * @param param 
   */
  public saveRelation(param) {
    return this.send(param, "saveRelation", Methods.POST)
  }
 /**
   * 监理信息化保存子项目和用户之间的关系 (分派人员)
   * @param param 
   */
     public zJSaveRelation(param) {
      return this.send(param, "zJSaveRelation", Methods.POST)
    }

  /**
   * 删除分派关系
   * @param userId 
   * @param projectDataId 
   * @returns 
   */
  public deleteRelation(param){
    return this.send(param, "deleteRelation", Methods.POST)
  }
  /**
   * 查询当前条件下用户列表
   * @param param 
   * @returns 
   */
  public getUserList(param,current,size,userName,userPhone,cidNo,delFlag){
    return this.send(param, "getUserList?current="+current+"&size="+size+"&userName="+userName+"&userPhone="+userPhone+"&cidNo="+cidNo+"&delFlag="+delFlag, Methods.GET)
  }
  /**
   * 查询当前机构下已经选过的人
   * @param projectDataId 
   * @param institutionId 
   */
  public getSelectUserList(projectDataId,institutionId){
    return this.send({projectDataId:projectDataId,institutionId:institutionId},"getSelectUserList",Methods.GET)
  }

  /**
   * 获取机构下的人和角色
   * @param institutionIds
   * @param subSystemId
   */
  public getUserRoleList(institutionIds, subSystemId: any = 0){
    return this.send({institutionIds:institutionIds,subSystemId:subSystemId},"getUserRoleList",Methods.GET)
  }

  /**
   * 查询机构下所有用户，按机构分组
   * @param param
   */
  public getInstitutionUserList(param){
    return this.send(param, "getInstitutionUserList", Methods.GET)
  }
  /**
     * 获取机构下用户信息
     * @returns 
     */
  public getUserListByInstitutionIdAndProjectId(projectId,institutionId){
    return this.send({projectId:projectId,institutionId:institutionId},"getUserListByInstitutionIdAndProjectId",Methods.GET)
  }
  /**
   * 还原用户到机构跟节点
   * @param institutionId 
   * @param projectDataId 
   * @returns 
   */
  public restoreUser(institutionId,projectDataId){
    return this.send({},"restoreUser?institutionId="+institutionId+"&projectDataId="+projectDataId,Methods.POST)
  }
  /**
   * 获取机构下用户信息
   * @returns
   */
  public getUserIdByInstitutionId(projectId,institutionId){
    return this.send({projectId:projectId,institutionId:institutionId},"getUserIdByInstitutionId",Methods.GET)
  }
  /**
   * 获取机构下的所有人
   * @param projectDataId 
   * @param institutionId 
   */
  public getUserListByBIId(projectDataId,institutionId){
    return this.send({projectDataId:projectDataId,institutionId:institutionId},"getUserListByBIId",Methods.GET)
  }
}